<template>
  <div>
    <slot name="content" v-bind="this"></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  mounted() {
    console.log('Im an example component');
  }
}
</script>
